import { render, staticRenderFns } from "./Longest.vue?vue&type=template&id=57d3ca7a&scoped=true"
import script from "./Longest.vue?vue&type=script&lang=js"
export * from "./Longest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d3ca7a",
  null
  
)

export default component.exports